import { ComponentProps } from "@declarations/props";
import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useLocation, useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import { BiFilterAlt } from "react-icons/bi";
import { SchoolService } from "@services/school.service";
import { useQuery } from "@tanstack/react-query";
// import { PopupConfirm } from "@components/general/popup";
// import Cookies from "js-cookie";

import MaleLogo from "@assets/images/avatar.png";
import FemaleLogo from "@assets/images/avatar-female.png";

export const Header: ComponentProps<{
  height?: number;
  // classOverlay?: string;
}> = ({ children, height = 210 }) => {
  return <>{children ?? <PageTitle />}</>;
};

const PageTitle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { header, setPopupStatus } = useThemeStore((state) => state);
  // const [popupLogout, setPopupLogout] = useState<boolean>(false);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "---";
  const gender = dataNis?.data?.gender ?? "";

  const { data, isPending } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
  });

  return (
    <>
      {location.pathname === linkPage.HOME_DASHBOARD ? (
        ""
      ) : (
        <>
          <div className={`tw-pt-4 tw-pb-6 tw-text-primary page-header`}>
            <div className="tw-px-4">
              {header.filter && (
                <div
                  className="tw-flex tw-shrink-0 tw-items-center"
                  onClick={() => setPopupStatus(true)}
                >
                  <BiFilterAlt size={25} />
                </div>
              )}

              {header.buttonBack && (
                <span
                  onClick={() => navigate(-1)}
                  className="tw-mb-2 tw-flex tw-items-center tw-cursor-pointer"
                >
                  <BsArrowLeft size={20} />
                </span>
              )}

              <div className="tw-grow tw-text-left">
                <div className="tw-text-xl tw-font-medium tw-line-clamp-1 tw-w-[95%]">
                  {header.title ?? <>Nama Halaman</>}
                </div>
              </div>

              <div
                className="tw-flex tw-shrink-0 tw-items-center"
                onClick={() => navigate(linkPage.HOME_PROFILE)}
              >
                {header.image && (
                  <img
                    src={
                      isPending
                        ? MaleLogo
                        : data?.data?.foto === null || data?.data?.foto === ""
                        ? gender === "Pria" ||
                          gender === "PRIA" ||
                          gender === ""
                          ? MaleLogo
                          : FemaleLogo
                        : `https://sipiat2.pesantrenalirsyad2.org/assets/fotosiswa/${data?.data?.foto}`
                    }
                    alt=""
                    className="tw-w-[45px] tw-h-[45px] tw-object-cover tw-rounded-full tw-aling-middle"
                  />
                )}
              </div>

              {/* {header.buttonLogout && (
              <div
                className="tw-flex tw-shrink-0 tw-items-center"
                onClick={() => setPopupStatus(true)}
              >
                <BiLogOut size={25} />
              </div>
            )} */}
            </div>
          </div>
        </>
      )}
    </>
  );
};
